
const client = require('superagent');
const EventEmitter = require('events').EventEmitter;

module.exports = (params) => {
    params = params || {};
    const token = params.token;
    const endpoint = params.endpoint;
    const errorHandler = params.errorHandler || ((err) => console.error(err));
    const monitor = params.monitor;

    return {
        get: function (path, data, done) {
            if (typeof(data) === 'function') {
                return this.request('get', path, {}, data);
            }
            return this.request('get', path, {
                data: data
            }, done);
        },
        post: function(path, data, done) {
            return this.request('post', path, {
                data: data
            }, done);
        },
        upload: function(path, files, data, done) {
            return this.request('post', path, {
                builder: (req) => {
                    files.forEach(v => {
                        req = req.attach(v.field, v.file);
                    });
                    Object.keys(data).forEach(k => {
                        if (data[k] === undefined) return;
                        req = req.field(k, data[k]);
                    });
                    return req;
                }
            }, done);
        },
        request: function(method, path, options, done) {
            method = method.toLowerCase();
            options = options || {};

            const data = options.data || {};
            const headers = options.headers || {};

            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }

            let req = client[method](this.resolveUrl(path));

            if (options.builder) {
                req = options.builder(req);
            } else {
                req = req.type('json');
                if (method === 'get') {
                    req = req.query(data);
                } else {
                    req = req.send(data);
                }
            }

            Object.keys(headers).forEach(k => {
                req.set(k, headers[k]);
            });

            const event = new EventEmitter();
            req.end((err, res) => {
                if (err) {
                    if (res && res.text) {
                        try {
                            const json = JSON.parse(res.text);
                            const error = new Error(json.error);
                            event.emit('error', error);
                            errorHandler(error);
                            return event.emit('end');
                        } catch (e) {}
                    }
                    event.emit('error', err);
                    errorHandler(err);
                    return event.emit('end');
                }

                console.log('[RAW RESPONSE]', res.statusCode, res.text);

                try {
                    const ret = JSON.parse(res.text);
                    if (ret.error) {
                        return errorHandler(new Error(ret.error));
                    }
                    done(ret);
                    return event.emit('end');
                } catch (e) {
                    event.emit('error', e);
                    errorHandler(e);
                    return event.emit('end');
                }
            });

            return event;
        },
        resolveUrl: function(path) {
            if (path.startsWith('http')) {
                return path;
            }
            return endpoint.replace(/\/$/ig, '') + '/' + path.replace(/^\//ig, '');
        }
    }
};
